import { Component, OnInit, ViewChild } from '@angular/core';
import { OneWayQuoteModel } from "./one-way-details.model";
import { ActivatedRoute, Router } from "@angular/router";
import { OneWayRequestService } from "./oneway-request-details.service";
import { ApiRoutes } from "../../../services/apiroutes";
import { LeadSubmitService } from '../lead-submit/lead-submit.service';
import { AuthService } from 'src/app/services/auth.service';

interface currency {
    value: string;
    viewValue: string;
    icon: string;
}

interface condition {
    value: string;
    viewValue: string;
    cost?: string;
}

@Component({
    selector: 'app-one-way-details',
    templateUrl: './one-way-details.component.html',
    styleUrls: ['../request-details.scss']
})
export class OneWayDetailsComponent implements OnInit {

    model: OneWayQuoteModel;
    modelService: LeadSubmitService;
    insuranceUrl = `${ApiRoutes.Insurance}insurance/?search=::search::`
    checked = true;
    savingCommercials: boolean = false;
    detailGathering: boolean;
    slideOut: boolean;
    slideIn: boolean;
    celebrate: boolean = false;
    whatsapp: boolean = false;
    value = "ARCU29292";
    @ViewChild('sideimage') sideimage: any;
    @ViewChild('confirmation') confirmation: any;

    // save() {
    //   if (this.model.is_valid()) {
    //     this.oneWayRequestService.saveOneWayQuote().subscribe((response) => {
    //       this.slideOut = true;
    //       setTimeout(() => {
    //         this.sideimage.nativeElement.style.height = "100vh";
    //         this.detailGathering = false;
    //       }, 600);
    //       setTimeout(() => {
    //         this.slideIn = true;
    //         this.celebrate = true;
    //       }, 900);
    //     });
    //   }
    // }

    yay = {
        fullScreen: {
            zIndex: 1
        },
        particles: {
            number: {
                value: 0
            },
            color: {
                value: [
                    "#00FFFC",
                    "#FC00FF",
                    "#fffc00"
                ]
            },
            shape: {
                type: "square",
                options: {}
            },
            opacity: {
                value: 1,
                animation: {
                    enable: true,
                    minimumValue: 0,
                    speed: 2,
                    // startValue: StartValueType.max,
                    // destroy: DestroyType.min
                }
            },
            size: {
                value: 4,
                random: {
                    enable: true,
                    minimumValue: 2
                }
            },
            links: {
                enable: false
            },
            life: {
                duration: {
                    sync: true,
                    value: 5
                },
                count: 1
            },
            move: {
                enable: true,
                gravity: {
                    enable: true,
                    acceleration: 10
                },
                speed: {
                    min: 10,
                    max: 20
                },
                decay: 0.1,
                // direction: MoveDirection.none,
                // straight: false,
                // outModes: {
                //     default: OutMode.destroy,
                //     top: OutMode.none
                // }
            },
            rotate: {
                value: {
                    min: 0,
                    max: 360
                },
                direction: "random",
                move: true,
                animation: {
                    enable: true,
                    speed: 60
                }
            },
            tilt: {
                direction: "random",
                enable: true,
                move: true,
                value: {
                    min: 0,
                    max: 360
                },
                animation: {
                    enable: true,
                    speed: 60
                }
            },
            roll: {
                darken: {
                    enable: true,
                    value: 25
                },
                enable: true,
                speed: {
                    min: 15,
                    max: 25
                }
            },
            wobble: {
                distance: 30,
                enable: true,
                move: true,
                speed: {
                    min: -15,
                    max: 15
                }
            }
        },
        emitters: {
            life: {
                count: 0,
                duration: 0.1,
                delay: 0.4
            },
            rate: {
                delay: 0.1,
                quantity: 150
            },
            size: {
                width: 0,
                height: 0
            }
        },
        duration: 4,
        style: {
            transition: 'opacity 2s ease-out 2s',
            opacity: '0'
        }
    }
    rain = {
        fullScreen: {
            zIndex: 1
        },
        particles: {
            color: {
                value: [
                    "#F05F25",
                    "#414042",
                    "#9E9E9E",
                    "#FF9064"
                ]
            },
            move: {
                // direction: MoveDirection.bottom,
                // enable: true,
                // outModes: {
                //     default: OutMode.out,
                // },
                size: true,
                speed: {
                    min: 1,
                    max: 3
                }
            },
            number: {
                value: 500,
                density: {
                    enable: true,
                    area: 800
                }
            },
            opacity: {
                value: 1,
                animation: {
                    enable: false,
                    // startValue: StartValueType.max,
                    // destroy: DestroyType.min,
                    speed: 0.3,
                    sync: true
                }
            },
            rotate: {
                value: {
                    min: 0,
                    max: 360
                },
                direction: "random",
                move: true,
                animation: {
                    enable: true,
                    speed: 60
                }
            },
            tilt: {
                direction: "random",
                enable: true,
                move: true,
                value: {
                    min: 0,
                    max: 360
                },
                animation: {
                    enable: true,
                    speed: 60
                }
            },
            shape: {
                type: [
                    "circle",
                    "square"
                ],
                options: {}
            },
            size: {
                value: {
                    min: 2,
                    max: 4
                }
            },
            roll: {
                darken: {
                    enable: true,
                    value: 30
                },
                enlighten: {
                    enable: true,
                    value: 30
                },
                enable: true,
                speed: {
                    min: 15,
                    max: 25
                }
            },
            wobble: {
                distance: 30,
                enable: true,
                move: true,
                speed: {
                    min: -15,
                    max: 15
                }
            }
        },
        duration: 6,
        style: {
            transition: 'opacity 2s ease-out 2s',
            opacity: '0'
        }
    }

    // async particlesInit(engine: Engine): Promise<void> {
    //     // console.log(engine);

    //     // Starting from 1.19.0 you can add custom presets or shape here, using the current tsParticles instance (main)
    //     // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    //     // starting from v2 you can add only the features you need reducing the bundle size
    //     await loadFull(engine);
    // }

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private oneWayRequestService: OneWayRequestService,
        private leadSubmitService: LeadSubmitService,
        private authService: AuthService
    ) {
        this.detailGathering = false;
        // this.slideOut = true;
        this.slideIn = false;
    }

    ngOnInit(): void {
        // get lead_if from queryParam
        this.route.queryParams.subscribe(params => {
            this.modelService = this.leadSubmitService;

            if (params['lead_id']) {
                this.leadSubmitService.saveLeadRequest(params['lead_id']).subscribe(response => {
                    // this.slideOut = true;
                    this.sideimage.nativeElement.style.height = "100vh";
                    this.detailGathering = false;
                    this.slideIn = true;
                    this.celebrate = true;
                })
            } else {
                // @TODO: show a snackbar with error message
                alert('Ooops Something went wrong. Kindly raise a new request');

                this.router.navigateByUrl('/web-request');
            }
        });
        // this.route.queryParams.subscribe(params => {

        //   if (params['lead_id']) {
        //     this.oneWayRequestService.newOneWayQuote(params['lead_id'])
        //     this.model = this.oneWayRequestService.onewayQuote;
        //     this.whatsapp_number_backup = this.model.whatsapp_number;

        //   } else {
        //     // @TODO: show a snackbar with error message
        //     alert('Ooops Something went wrong. Kindly raise a new request');

        //     this.router.navigateByUrl('/web-request');
        //   }


        // });
    }

    navigateToQuotation() { // not needed as per new flow use navigateToOrdersPage instead
        this.slideIn = false;
        setTimeout(() => {
            this.sideimage.nativeElement.style.height = "100vh";
            this.detailGathering = true;
            this.route.queryParams.subscribe(params => {
                if (params['lead_id']) {
                    this.oneWayRequestService.newOneWayQuote(params['lead_id'])
                    this.model = this.oneWayRequestService.onewayQuote;
                }
            });
            // setTimeout(() => {
            //   this.slideOut = false;
            // }, 900);
        }, 600);
    }

    navigateToLogin(requirement) {
        if (this.model.is_valid()) {
            this.oneWayRequestService.saveOneWayQuote(requirement.id).subscribe((response) => {
                this.router.navigateByUrl('/authentication/login');
            });
        }
    }

    navigateToOrdersPage(requirement) {
        this.savingCommercials = true;
        if (this.authService.isCustomer() || this.model.is_valid()) {
            this.oneWayRequestService.saveOneWayQuote(requirement.id).subscribe({
                next: res => {
                    if (this.authService.isCustomer()) {
                        this.router.navigateByUrl('/client-dashboard/my-orders');
                    } else {
                        this.router.navigateByUrl('/requests/request-processing');
                    }
                },
                error: err => {
                    this.savingCommercials = false;
                }
            });
        } else {
            this.savingCommercials = false;
        }
    }
    //skip button
    skip() {
        this.router.navigate(['/client-dashboard/my-orders']);
    }

}
